import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      width: '100%',
    },
    itemText: {
      textTransform: 'uppercase',
    },
  }),
);

export default useStyles;
